export type RegisterAbsenceEmployee = {
  id: number;
  name?: string;
  number?: number | string;
};

type OpenRegisterAbsenceDialogArgs = {
  employee: RegisterAbsenceEmployee;
  /** Prefills the start date of the absence */
  startDate?: Date;
  /** Prefills the end date of the absence */
  endDate?: Date;
  /** When set, the dialog only offers duty hour types with one of these codes */
  allowedDutyHourTypeCodes?: string[];
  onSuccess?: () => void;
};

export const OPEN_REGISTER_ABSENCE_DIALOG_TOPIC = 'openRegisterAbsenceDialog';

/**
 * Opens the Dojo "Afwezigheid vastleggen" (RegisterAbsenceDialog) widget for the given
 * employee. The Dojo side (aysist/sdbplanning) creates and shows the widget, so it works
 * from any React screen. Requires the ROSTER_PORTAL_ROSTER_ABSENCE_PROCEDURE grant.
 */
export const openRegisterAbsenceDialog = (
  args: OpenRegisterAbsenceDialogArgs
) => {
  if (!window.dojoTopic) {
    console.error(
      'Cannot open the register absence dialog: the Dojo application is not loaded'
    );
    return;
  }

  window.dojoTopic.publish(OPEN_REGISTER_ABSENCE_DIALOG_TOPIC, args);
};
